<ng-container *ngTemplateOutlet="mode() === 'home' ? homefilter : nohomefilter"></ng-container>

<ng-template #homefilter>
    @switch (mediaService.media()) {
    @case ('xs') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @case ('sm') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @case ('md') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @default {
    <ng-container *ngTemplateOutlet="homefilterdesk"></ng-container>
    }
    }
</ng-template>

<ng-template #nohomefilter>
    @if(mode() === 'nohomesmall') {
    {{local_start() | date:'dd.MM.yyyy'}} - {{local_end() | date:'dd.MM.yyy'}}
    } @else {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
</ng-template>

<ng-template #homemodeMobile>
    <div class="searchBoxWrapper_mobile customflex" #mdbuttondesk="cdkOverlayOrigin"
        [class.searchBoxWrapperactive]="showModal()" cdkOverlayOrigin (click)="openModal()" ng-clickOutside
        (clickOutside)="closeModal()">
        <div class="wrapper">
            <span class="description">Reisezeitraum</span>
            <p class="w90">{{local_start() | date:'dd.MM.yyyy'}} - {{local_end() | date:'dd.MM.yyyy'}} {{local_dauername() ? ', ' +
                local_dauername() : ''}}</p>
        </div>
        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttondesk"
            [cdkConnectedOverlayPositions]="overlaypos" [cdkConnectedOverlayOpen]="showModal()"
            [cdkConnectedOverlayHasBackdrop]="false" (backdropClick)="closeModal()">
            <ng-container *ngTemplateOutlet="modal"></ng-container>
        </ng-template>
    </div>
</ng-template>

<ng-template #homefilterdesk>
    <div class="searchBoxWrapper" [style.width]="customwidth()" #mdbuttondesk="cdkOverlayOrigin" [class.searchBoxWrapperactive]="showModal()"
        cdkOverlayOrigin (click)="openModal()" ng-clickOutside (clickOutside)="closeModal()">
        <div class="wrapper">
            <span class="description">Reisezeitraum</span>
            <p class="w90">{{local_start() | date:'dd.MM.yyyy'}} - {{local_end() | date:'dd.MM.yyyy'}} {{local_dauername() ? ', ' +
                local_dauername() : ''}}</p>
        </div>
        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttondesk"
            [cdkConnectedOverlayPositions]="overlaypos" [cdkConnectedOverlayOpen]="showModal()"
            [cdkConnectedOverlayHasBackdrop]="false" (backdropClick)="closeModal()">
            <ng-container *ngTemplateOutlet="modal"></ng-container>
        </ng-template>
    </div>
</ng-template>

<ng-template #modal>
    @switch (mediaService.media()) {
    @case ('xs') {
    <ng-container *ngTemplateOutlet="mobileModal"></ng-container>
    }
    @case ('sm') {
    <ng-container *ngTemplateOutlet="mobileModal"></ng-container>
    }
    @default {
    <ng-container *ngTemplateOutlet="modeDesk"></ng-container>
    }
    }
</ng-template>

<ng-template #modeDesk>
    <div class="custompopupwrapper mat-elevation-z1">
        <div class="popupbody" (click)="$event.stopPropagation()">
            <clever-cleverdatepicker [start]="local_start()" [end]="local_end()" [mindauer]="local_mindauer()"
                [maxdauer]="local_maxdauer()" (sendRes)="sendRes($event)"></clever-cleverdatepicker>
        </div>
    </div>
</ng-template>

<ng-template #mobileModal>
    <div class="backdropwrapper-mobile">
        <div class="filterwrapper-mobile">
            <button class="shettheader" (click)="closeModalMobile()" #searchheader>
                <img src="../../../../../assets/tvg/leftdirection.svg" alt="goback icon">
                <span>Wann reisen Sie?</span>
            </button>
            <div class="custompopupwrapper-mobile">
                <div class="popupbody" (click)="$event.stopPropagation()">
                    <clever-cleverdatepicker class="h100" [start]="local_start()" [end]="local_end()"
                        [mindauer]="local_mindauer()" [maxdauer]="local_maxdauer()"
                        (sendRes)="sendRes($event)"></clever-cleverdatepicker>
                </div>
            </div>
        </div>
    </div>
</ng-template>